import type { IFeatureFlipRepository } from '../domain/IFeatureFlipRepository'
import type { Feature } from '../domain/Feature'
import { FeatureType } from '../domain/FeatureType'
import type { FeatureFlipIzanamiDataSource } from './FeatureFlipIzanamiDataSource'
import type { FeatureFlipEnvDataSource } from './FeatureFlipEnvDataSource'
import type { FeatureFlipCacheDataSource } from './FeatureFlipCacheDataSource'

export class FeatureFlipRepository implements IFeatureFlipRepository {
  constructor(
    protected readonly izanamiDataSource: FeatureFlipIzanamiDataSource,
    protected readonly configDataSource: FeatureFlipEnvDataSource,
    protected readonly cacheDataSource: FeatureFlipCacheDataSource,
    protected readonly brand: string,
  ) {}

  public async checkFeature(feature: Feature, { forceUpdate }: { forceUpdate?: boolean } = {}): Promise<boolean> {
    const featureName = `${this.brand}:${feature.id}`
    if (!forceUpdate) {
      const cachedResult = this.cacheDataSource.check(feature.id)
      if (cachedResult !== undefined) return cachedResult
    }

    const isActive =
      feature.type === FeatureType.Dynamic
        ? await this.izanamiDataSource.check(featureName, feature.context)
        : this.configDataSource.check(feature.id)

    this.cacheDataSource.store(feature.id, isActive)

    return isActive
  }
}
